import { render, staticRenderFns } from "./proteine.vue?vue&type=template&id=254bb7ce&scoped=true&"
import script from "./proteine.vue?vue&type=script&lang=js&"
export * from "./proteine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254bb7ce",
  null
  
)

export default component.exports